import React, { useContext, useState } from "react";
import { Button, Box, Tooltip, Avatar, IconButton, Menu, MenuItem, ListItemIcon } from "@mui/material";
import { userAvatarSrc } from "utils/userAvatarSrc";
import RevaText from "components/common/RevaText";
import { useLanguage } from "context/LanguageProvider";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import TranslateIcon from "@mui/icons-material/Translate";
import BusinessIcon from "@mui/icons-material/Business";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { Logout } from "@mui/icons-material";
import { ROUTES } from "constants/routes";
import UserContext from "context/UserContext";
import { useGestionNavigation } from "hooks/useGestionNavigation";
import DashboardModeSwitcher from "./DashboardModeSwitcher";

const LinksTopBar = ({ handleLogoutClick }) => {
  const { locale, switchLanguage } = useLanguage();
  const intl = useIntl();
  const { user, changeUser } = useContext(UserContext);
  const { hasGestionAccess, gestionHomePath } = useGestionNavigation();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [langMenuAnchor, setLangMenuAnchor] = useState(null);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLangMenuOpen = (event) => setLangMenuAnchor(event.currentTarget);
  const handleLangMenuClose = () => setLangMenuAnchor(null);

  const handleLanguageChange = (lang) => {
    switchLanguage(lang);
    handleLangMenuClose();
    handleMenuClose();
  };

  return (
    <Box flexGrow={1} display="flex">
      <Box sx={{ flexGrow: 1, display: "flex" }} gap={2}>
        {/* <Button href="/rankings" edge="end" color="inherit">
          Rankings
        </Button> */}
      </Box>
      <Box flexGrow={0} display="flex" alignItems="center">
        {user && <DashboardModeSwitcher />}
        {user && (
          <Box>
            <Tooltip title={user.full_name}>
              {user.profile_pic ? (
                <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
                  <Avatar
                    alt="avatar"
                    src={userAvatarSrc(user.profile_pic)}
                  />
                </IconButton>
              ) : (
                <RevaText color="inherit" onClick={handleMenuOpen}>
                  {`${user.first_name} ${user.last_name}`}
                </RevaText>
              )}
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              {hasGestionAccess && (
                <MenuItem onClick={() => history.push(gestionHomePath)}>
                  <ListItemIcon>
                    <ManageAccountsIcon />
                  </ListItemIcon>
                  {intl.formatMessage({ id: "gestion.menu" })}
                </MenuItem>
              )}
              {user.organizations?.length >= 1 && (
                <MenuItem onClick={() => history.push(ROUTES.ADMIN.ORGANIZATIONS)}>
                  <ListItemIcon>
                    <BusinessIcon />
                  </ListItemIcon>
                  {intl.formatMessage({ id: "Mis organizaciones" })}
                </MenuItem>
              )}

              {/* Selector de Idiomas dentro del menú */}
              <MenuItem onClick={handleLangMenuOpen}>
                <ListItemIcon>
                  <TranslateIcon />
                </ListItemIcon>
                {intl.formatMessage({ id: "Idioma" })}
              </MenuItem>

              {/* Submenú para cambiar idioma */}
              <Menu anchorEl={langMenuAnchor} open={Boolean(langMenuAnchor)} onClose={handleLangMenuClose}>
                <MenuItem selected={locale === "es"} onClick={() => handleLanguageChange("es")}>
                  <ListItemIcon>🇪🇸</ListItemIcon>
                  {intl.formatMessage({ id: "Español" })}
                </MenuItem>
                <MenuItem selected={locale === "en"} onClick={() => handleLanguageChange("en")}>
                  <ListItemIcon>🇺🇸</ListItemIcon>
                  {intl.formatMessage({ id: "Inglés" })}
                </MenuItem>
              </Menu>

              <MenuItem onClick={() => handleLogoutClick(changeUser)}>
                <ListItemIcon>
                  <Logout />
                </ListItemIcon>
                <RevaText id="Cerrar sesión" sx={{ textAlign: "center" }} />
              </MenuItem>
            </Menu>
          </Box>
        )}
        {!user && (
          <Button href="/signin" edge="end" color="inherit">
            Login
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default LinksTopBar;
